import { getHoverColor } from "@/utils/colorUtils"
import { $color, $shadow } from "@/utils/cssVarUtils"
import { menuAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleFunction,
  SystemStyleFunction,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"


const baseStyleList: SystemStyleFunction = (props) => {

  return {
    bg: $color('bg-normal'),
    boxShadow: $shadow('normal'),
    color: $color('text-normal'),
    minW: '12.5rem',
    borderRadius: '2xs',
    border: 'none',
    p: 0,
    fontSize: 'sm',
    overflow: 'hidden',
  }
}

const baseStyleItem: SystemStyleFunction = (props) => {
  const hoverColor = getHoverColor(props)
  
  return {
    py: 0,
    px: '2xl',
    h: '5xl',
    _hover: {
      bg: hoverColor,
    },
    _checked: {
      bg: 'transparent',
      _hover: {
        bg: hoverColor,
      }
    },
    _focus: {
      background: 'transparent',
    },
    _disabled: {
      _hover: {
        bg: 'transparent',
      }
    },
    "> span > svg": {
      color: $color('scene-primary-normal'),
    },
  }
}

const baseStyleGroupTitle: SystemStyleObject = {
  mx: 0,
  my: 0,
  px: '2xl',
  h: '5xl',
  fontWeight: "semibold",
  display: 'flex',
  alignItems: 'center',
}

const baseStyleCommand: SystemStyleObject = {
  opacity: 0.6,
}

const baseStyleDivider: SystemStyleObject = {
  borderColor: $color('scene-border'),
  m: 0,
}

const baseStyleButton: SystemStyleObject = {
  transitionProperty: "common",
  transitionDuration: "normal",
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  button: baseStyleButton,
  list: baseStyleList(props),
  item: baseStyleItem(props),
  groupTitle: baseStyleGroupTitle,
  command: baseStyleCommand,
  divider: baseStyleDivider,
})

export const Menu = {
  parts: parts.keys,
  baseStyle,
}